export default __webpack_public_path__ + "static/help_06_05_2-d40d145a3337c57634fbb1e3efc7bddd.png";